



























import {Component, Prop, Vue} from 'vue-property-decorator';
import {PortfolioCompany} from '@/store/models';
import SidebarPortfolio from '@/views/SidebarPortfolio.vue';

@Component({
  components: {SidebarPortfolio},
})
export default class PortfolioCompanyItem extends Vue {
    @Prop() company: PortfolioCompany | undefined;
}
